module.exports = __webpack_public_path__ + "static/assets/74687209fbf0d6d55551cac4876dd514.svg";